import { render } from "./App.vue?vue&type=template&id=83f030a4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83f030a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83f030a4', __exports__)) {
    api.reload('83f030a4', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=83f030a4&ts=true", () => {
    api.rerender('83f030a4', render)
  })

}


export default __exports__